import { Button } from '@axo/ui-core/components/Button';
import { DataFetchedFrom } from '@axo/shared/data-access/types';
import { useAuthenticationContext } from '../../../../../context/Authentication/AuthenticationContext';
import { useAxoFormContext } from '../../../../../context/AxoForm/AxoForm';
import { MitIDActions, MitIDSuccess } from './MitIDGroup';
import { useState } from 'react';
import { useTranslation } from '@axo/shared/i18n';
import { Stack } from '@axo/ui-core/components/layout/item';

export const Step9 = () => {
  const { t } = useTranslation();
  const { isAuthenticated } = useAuthenticationContext();
  const { axoFormData } = useAxoFormContext();
  const [bypassAuthentication, setBypassAuthentication] = useState(false);

  const searchParams = new URLSearchParams(window.location.search);
  const isInternal = searchParams.get('traffic') === 'internal';

  const _isAuthenticated =
    isAuthenticated ||
    axoFormData['LoanApplication/DataFetchedFrom'] === DataFetchedFrom.Uniify ||
    bypassAuthentication;

  return (
    <>
      <MitIDActions />

      {isInternal && (
        <Stack>
          <Button
            type="button"
            variant="secondary"
            size="l"
            onClick={() => setBypassAuthentication(true)}
          >
            {t('submit')}
          </Button>
        </Stack>
      )}

      {_isAuthenticated && <MitIDSuccess />}
    </>
  );
};
